import type { RouteObject } from 'react-router-dom';
import { formatPhoneNumber } from '../format/PhoneNumber';
import { lazyElement } from '../routing/lazyRoute';

const accountRoutes: RouteObject[] = [
  {
    path: '/account/:phoneNumber',
    element: lazyElement(() => import('./View')),
    handle: {
      crumb: () => ({ label: 'Account' }),
      buildDocumentTitle: (params) => {
        const raw = params.phoneNumber;
        if (raw == null || raw.trim() === '') {
          return undefined;
        }
        const decoded = decodeURIComponent(raw);
        return formatPhoneNumber(decoded);
      },
    },
  },
];

export default accountRoutes;
